/**
 * @generated SignedSource<<65f7487bbf2166c21de5aefdce342ece>>
 * @relayHash 0ace672294c09b398fb8d4f0e7526c83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_NotificationsPageAndProjectQuery$variables = {
  cloudId: string;
};
export type ui_NotificationsPageAndProjectQuery$data = {
  readonly jira: {
    readonly notificationGlobalPreference: {
      readonly options: {
        readonly " $fragmentSpreads": FragmentRefs<"notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects">;
};
export type ui_NotificationsPageAndProjectQuery = {
  response: ui_NotificationsPageAndProjectQuery$data;
  variables: ui_NotificationsPageAndProjectQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider: {
    readonly get: () => boolean;
  };
});

import includeMiscellaneousCombinedType_provider from '@atlassian/jira-relay-provider/src/include-miscellaneous-events-combined-type.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "concreteType": "JiraAvatar",
    "kind": "LinkedField",
    "name": "avatar",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "xsmall"
      }
    ]
  }
],
v6 = [
  {
    "kind": "ScalarField",
    "name": "channel"
  },
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "isEditable"
  }
],
v7 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "type"
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "emailChannel",
    "plural": false,
    "selections": (v6/*: any*/)
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "inProductChannel",
    "plural": false,
    "selections": (v6/*: any*/)
  },
  {
    "kind": "ScalarField",
    "name": "category"
  }
],
v8 = {
  "concreteType": "JiraNotificationPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueAssigned",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueUpdated",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueDeleted",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "commentCreated",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "commentEdited",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "commentDeleted",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueCreated",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "issueMoved",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "mentionsCombined",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "worklogCombined",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "miscellaneousIssueEventCombined",
      "plural": false,
      "selections": (v7/*: any*/)
    }
  ]
},
v9 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_NotificationsPageAndProjectQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "concreteType": "JiraNotificationGlobalPreference",
                "kind": "LinkedField",
                "name": "notificationGlobalPreference",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraNotificationOptions",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.notificationGlobalPreference.options"
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.notificationGlobalPreference"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ui_NotificationsPageAndProjectQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraNotificationProjectPreferenceConnection",
            "kind": "LinkedField",
            "name": "allNotificationProjectPreferences",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectNotificationPreferenceEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraNotificationProjectPreferences",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v9/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "totalCount"
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              (v9/*: any*/)
            ]
          },
          {
            "args": (v3/*: any*/),
            "filters": [
              "cloudId"
            ],
            "handle": "connection",
            "key": "projects_allNotificationProjectPreferences",
            "kind": "LinkedHandle",
            "name": "allNotificationProjectPreferences"
          },
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraNotificationGlobalPreference",
            "kind": "LinkedField",
            "name": "notificationGlobalPreference",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isEmailNotificationEnabled"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "notifyWhenRoleAssigneeEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "notifyWhenRoleReporterEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "notifyOwnChangesEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "batchWindow"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "dailyBatchLocalTime"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "emailMimeType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isEmailMimeTypeEditable"
                  }
                ]
              },
              (v8/*: any*/)
            ]
          },
          {
            "alias": "allJiraProjectsForModal",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "notificationConfigurationState": "DEFAULT",
                  "sortBy": {
                    "sortBy": "NAME"
                  }
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              }
            ],
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b7fd514c01c704c310af24b4bec2490f86683eb6f578c5e61833c2151685f3ba",
    "metadata": {},
    "name": "ui_NotificationsPageAndProjectQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
    }
  }
};
})();

(node as any).hash = "b001322577b49b90b0c0e44082f4b2b8";

export default node;
